import React, { useState, useEffect } from 'react';
import ResidentList from './ResidentList';
import NotificationSend from './NotificationSend';
import UnregisteredList from './UnregisteredList';
import AdminSettings from './AdminSettings';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Dashboard({ onLogout }) {
  const [activeTab, setActiveTab] = useState('residents');
  const [unregisteredCount, setUnregisteredCount] = useState(0);

  // 未登録者数を定期的に取得
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const response = await fetch(`${API_URL}/api/unregistered`);
        const data = await response.json();
        if (data.success) setUnregisteredCount(data.unregistered.length);
      } catch (error) {
        console.error('未登録者数取得エラー:', error);
      }
    };

    fetchCount();
    // 30秒ごとに更新
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const tabs = [
    { id: 'residents', label: '住民管理' },
    { id: 'notifications', label: '通知送信' },
    {
      id: 'unregistered',
      label: 'LINE未登録',
      badge: unregisteredCount
    },
    { id: 'settings', label: '設定' }
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {/* ヘッダー */}
      <header style={{
        backgroundColor: '#4CAF50',
        color: 'white',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h1 style={{ margin: 0 }}>生存確認システム - 管理者画面</h1>
          <button
            onClick={onLogout}
            style={{
              padding: '10px 20px',
              backgroundColor: 'white',
              color: '#4CAF50',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            ログアウト
          </button>
        </div>
      </header>

      {/* ナビゲーション */}
      <nav style={{
        backgroundColor: 'white',
        borderBottom: '1px solid #ddd',
        padding: '0 20px'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          gap: '10px'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '15px 30px',
                backgroundColor: activeTab === tab.id ? '#4CAF50' : 'transparent',
                color: activeTab === tab.id ? 'white' : '#333',
                border: 'none',
                borderBottom: activeTab === tab.id ? '3px solid #4CAF50' : 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '16px',
                position: 'relative'
              }}
            >
              {tab.label}
              {tab.badge > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '1px 6px',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  {tab.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      </nav>

      {/* コンテンツエリア */}
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        {activeTab === 'residents' && <ResidentList />}
        {activeTab === 'notifications' && <NotificationSend />}
        {activeTab === 'unregistered' && <UnregisteredList />}
        {activeTab === 'settings' && <AdminSettings />}
      </main>
    </div>
  );
}

export default Dashboard;
